import { consoleLog } from "../../../utils/log-utils";
import {
  listRequest,
  createUpdateRequest,
  storeTagListRequest,
  updateStoreTagsRequest,
} from "../../service/TagService";

/**
 *
 * @param {*} data  JSON DATA TO SEND TO SERVER
 * @returns API RESULT
 */
export const listAction = () => async (dispatch) => {
  const response = await dispatch(listRequest());
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const createUpdateAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(createUpdateRequest(requestBody));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const storeTaglistAction = (data) => async (dispatch) => {
  const response = await dispatch(storeTagListRequest(data));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const updateStoreTagsAction = (requestBody) => async (dispatch) => {
  const response = await dispatch(updateStoreTagsRequest(requestBody));
  consoleLog("",response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("",response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
